export function validarDigitoData(digito: string): boolean {
    const pattern = /[0-9]|\//;
    if (pattern.test(digito)) {
        return true;
    }

    return false;
}
